var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-details-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            fullscreen: true,
            "close-on-press-escape": false,
            "show-close": false,
            "close-on-click-modal": false,
            visible: _vm.formVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.formVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "one-off-request-title-bar",
              attrs: { id: "one-off-request-title" },
            },
            [
              !_vm.showFinalStep
                ? _c(
                    "button",
                    {
                      staticClass: "el-dialog__headerbtn",
                      staticStyle: { right: "unset", left: "20px" },
                      attrs: { type: "button", "aria-label": "Back" },
                      on: { click: _vm.back },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "el-dialog__close el-icon el-icon-arrow-left",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "order-number" }, [
                _vm._v("\n        One-off\n      "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:visible", false)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-close",
                  }),
                ]
              ),
              _vm._v(" "),
              _c("StepProgressBar", {
                attrs: {
                  "total-steps": _vm.totalSteps,
                  "current-step": _vm.currentStep,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "one-off-request-body",
                  attrs: { id: "one-off-request-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "one-off-request-steps" },
                    [
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 1: Review customer details",
                          isactive: _vm.isActive1,
                          "current-value": 1,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 2: Search and choose item",
                          isactive: _vm.isActive2,
                          "current-value": 2,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 3: Select one-off reason",
                          isactive: _vm.isActive3,
                          "current-value": 3,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 4: One-off summary",
                          isactive: _vm.isActive4,
                          "current-value": 4,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "one-off-request-data",
                      attrs: { id: "one-off-request-data" },
                    },
                    [
                      _vm.currentStep === 4 && _vm.displayFinalStep
                        ? _c("OneOffSummary", {
                            attrs: {
                              loading: _vm.loading,
                              device: _vm.selectedItem,
                              "selected-name": _vm.selectedReasons.name,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                              "created-on": _vm.createdOn,
                            },
                            on: {
                              "update:loading": function ($event) {
                                _vm.loading = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 3 && !_vm.displayFinalStep
                        ? _c("OneOffReasons", {
                            attrs: {
                              device: _vm.selectedItem,
                              loading: _vm.loading,
                              "selected-group": _vm.selectedReasons.group,
                              "selected-reason": _vm.selectedReasons.reason,
                            },
                            on: {
                              "update:loading": function ($event) {
                                _vm.loading = $event
                              },
                              "selected-group-and-reason":
                                _vm.getSelectedReasons,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 2
                        ? _c("ChooseOneOff", {
                            attrs: {
                              country: _vm.customerAddress.country,
                              state: _vm.customerAddress.state,
                              "zip-code": _vm.customerAddress.zip_code,
                              expedited: _vm.shippingOptions.expedited,
                              "selected-item": _vm.selectedItem,
                            },
                            on: {
                              "update:selectedItem": function ($event) {
                                _vm.selectedItem = $event
                              },
                              "update:selected-item": function ($event) {
                                _vm.selectedItem = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 1 && !_vm.isEditDetailsStep
                        ? _c("ReviewCustomerDetailsAddress", {
                            attrs: {
                              loading: _vm.loading,
                              "edit-details": _vm.isEditDetailsStep,
                              filled: _vm.customerDetailsFilled,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                            },
                            on: {
                              "update:editDetails": function ($event) {
                                _vm.isEditDetailsStep = $event
                              },
                              "update:edit-details": function ($event) {
                                _vm.isEditDetailsStep = $event
                              },
                              "update:filled": function ($event) {
                                _vm.customerDetailsFilled = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 1 && !_vm.isEditDetailsStep
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "expedited-shipping-option flex flex-auto flex-col",
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n            Shipping Options\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-card",
                                {
                                  staticStyle: { width: "20rem" },
                                  attrs: { shadow: "never" },
                                },
                                [
                                  _c("ExpeditedFormButton", {
                                    attrs: {
                                      expedited: _vm.shippingOptions.expedited,
                                    },
                                    on: {
                                      "update:expedited": function ($event) {
                                        return _vm.$set(
                                          _vm.shippingOptions,
                                          "expedited",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 1 && _vm.isEditDetailsStep
                        ? _c("EditCustomerDetail", {
                            ref: "editCustomer",
                            attrs: {
                              allvalid: _vm.editCustomerEnableSave,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                            },
                            on: {
                              "update:allvalid": function ($event) {
                                _vm.editCustomerEnableSave = $event
                              },
                              "update:customer": function ($event) {
                                _vm.customerDetails = $event
                              },
                              "update:address": function ($event) {
                                _vm.customerAddress = $event
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "one-off-request-footer",
              attrs: { id: "one-off-request-footer" },
            },
            [
              _vm.showAddressConfirmationCheck
                ? _c(
                    "el-checkbox",
                    {
                      staticClass: "confirm-checkbox",
                      staticStyle: { "margin-right": "24px" },
                      model: {
                        value: _vm.isConfirmed,
                        callback: function ($$v) {
                          _vm.isConfirmed = $$v
                        },
                        expression: "isConfirmed",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Customer details and address are correct.\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showBack
                ? _c(
                    "el-button",
                    {
                      staticClass: "action_button back",
                      on: { click: _vm.back },
                    },
                    [_vm._v("\n        Back\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showNext,
                      expression: "showNext",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: { disabled: _vm.isNextDisabled, type: "primary" },
                  on: { click: _vm.next },
                },
                [_vm._v("\n        Next\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 3 && !_vm.displayFinalStep,
                      expression: "currentStep === 3 && !displayFinalStep",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: { disabled: _vm.isReasonSelected, type: "primary" },
                  on: { click: _vm.finalStep },
                },
                [_vm._v("\n        Submit\n      ")]
              ),
              _vm._v(" "),
              _vm.showCancel
                ? _c(
                    "el-button",
                    {
                      staticClass: "action_button back",
                      staticStyle: {
                        color: "#1998d5 !important",
                        "margin-right": "2px",
                      },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showSaveChanges
                ? _c(
                    "el-button",
                    {
                      staticClass: "action_button",
                      attrs: {
                        type: "primary",
                        disabled: !_vm.editCustomerEnableSave,
                      },
                      on: { click: _vm.saveChanges },
                    },
                    [_vm._v("\n        Save Changes\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 4 && _vm.displayFinalStep,
                      expression: "currentStep === 4 && displayFinalStep",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: { type: "primary" },
                  on: { click: _vm.exit },
                },
                [_vm._v("\n        Done\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }